import React, {useState} from 'react';
import './GamePin.css';
import InputPin from "../../../Components/InputPin/InputPin";
import axios from "axios";

import QrReader from 'react-qr-reader';
import {useNavigate} from "react-router-dom";

const GamePin = ({ code, isModalOpen }) => {

    // const [gameEnterCode, setGameEnterCode] = useState(code);
    const [gameEnterCode, setGameEnterCode] = useState(null);
    const [gameOpenSuccess, setGameOpenSuccess] = useState('');
    const [gameOpenError, setGameOpenError] = useState(null);

    const navigate = useNavigate();

    const closePin = () => {
        isModalOpen(false);
    }

    const goToProfile = () => {
        navigate("/profile");
    }

    const verifyCode = (codeToVerify) => {
        // let data = {};
        // data['qr_code'] = gameEnterCode;

        const data = { qr_code: codeToVerify };

        axios.post(`/api/recieve/`, data, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res);
                setGameOpenSuccess('Дверь открыта!');
                closePin();
            })
            .catch(e => {
                console.log('Код неверный');
                setGameOpenError('Неверный код');
            })
    }

    const handleScan = (data) => {
        if (data) {
            if (/^\d{4}$/.test(data)) {
                console.log("QR data valid:", data);
                setGameEnterCode(data);
                // verifyCode(data);
            }
        }
    };

    const handleError = (err) => {
        console.log(err);
    };

    return (
        <div className={'game-pin-container'}>

            <div className={'game-pin-close-button'}>
                <svg x="0px" y="0px" viewBox="2.5 2.5 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"
                     onClick={() => closePin()}>
                    <path d="M5 5L19 19M5 19L19 5" stroke="#000000" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
            </div>

            <div className={'game-pin-qr'}>
                <QrReader
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    facingMode={'environment'}
                    showViewFinder={false}

                    // onResult={(result, error) => {
                    //     if (!!result) {
                    //         handleScan(result);
                    //         console.log('Result: ', result);
                    //     }
                    //
                    //     if (!!error) {
                    //         console.log(error);
                    //     }
                    // }}

                    style={{width: '100%', height: '100%'}}
                    // constraints={{ facingMode: 'environment' }}
                />
            </div>
            <div className={'game-pin-title'}>Считайте с экрана QR код или введите PIN</div>
            <div className={'game-pin-pin'}>
                <InputPin serverCode={gameEnterCode} setCode={setGameEnterCode}/>
            </div>
            <div
                className={`game-open-success ${gameOpenError ? 'game-open-error' : ''}`}>{gameOpenError ? gameOpenError : gameOpenSuccess}</div>
            <div className={'game-open-button-pin'} onClick={() => verifyCode(gameEnterCode)}>
                <p className={'game-open-button-text'}>Открыть дверь</p>
            </div>
            <div className={'game-back-button-pin'} onClick={() => goToProfile()}>
                <p className={'game-open-button-text'}>Мои игры</p>
            </div>
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default GamePin;